/**
 * Determines if a unit choice should be visible based on vehicles selection.
 * KM and MILES are only visible when ONLY vehicles is selected (no other energy sources).
 * @param {boolean} params[0] - whether ONLY vehicles is selected (vehicles selected AND count = 1)
 * @param {any} params[1] - the current item (could be value string or full object)
 * @returns {boolean} true if the choice should be visible
 */
function isUnitVisibleForVehicles(params: any[]) {
  const onlyVehiclesSelected = params[0];
  const item = params[1];
  const vehicleOnlyUnits = ["KM", "MILES"];

  // Handle both cases: item could be a string value or an object with .value
  const value = typeof item === "object" && item !== null ? item?.value : item;

  // If this is a vehicle-only unit (KM, MILES)
  if (vehicleOnlyUnits.includes(value)) {
    // Only show if ONLY vehicles is selected (no other energy sources)
    return !!onlyVehiclesSelected;
  }

  // All other units are always visible
  return true;
}

export default isUnitVisibleForVehicles;
